namespace RecordShield.Models {
    export enum EValidity {
        Zero = 0,
        One = 1,
        Two = 2,
        Three = 3,
        Four = 4,
        Five = 5,
        Six = 6,
        Seven = 7,
        Eight = 8,
        Nine = 9,
        Ten = 10,
        Eleven = 11,
        Twelve = 12,
        Thirteen = 13,
        Fourteen = 14,
        Fifteen = 15,
        Sixteen = 16,
        Seventeen = 17,
        Eighteen = 18,
        Nineteen = 19,
        Twenty = 20,
        TwentyOne = 21,
        TwentyTwo = 22,
        TwentyThree = 23,
        TwentyFour = 24,
        TwentyFive = 25,
        TwentySix = 26,
        TwentySeven = 27,
        TwentyEight = 28,
        TwentyNine = 29,
        OneMonth = 30,
        OneAndHalfMonth = 31,
        TwoMonths = 32,
        TwoAndHalfMonths = 33,
        ThreeMonths = 34,
        FourMonths = 35,
        FiveMonths = 36,
        SixMonths = 37,
        SevenMonths = 38,
        EightMonths = 39,
        NineMonths = 40,
        TenMonths = 41,
        ElevenMonths = 42,
        TwelveMonths = 43,
        FifteenMonths = 44,
        EighteenMonths = 45,
        TwoYears = 46,
        TwoAndHalfYears = 47,
        ThreeYears = 48,
        FiveYears = 49,
        SevenYears = 50,
        TenYears = 51,
        FifteenYears = 52,
        TwentyYears = 53,
        TwentyFiveYears = 54,
        ThirtyYears = 55,
        Unlimited = 56
    }
    Serenity.Decorators.registerEnum(EValidity, 'RecordShield.Models.EValidity');
}
